const ENVIRONMENT_STYLES = {
  production:
    'border-red-300 bg-red-50 text-red-800 dark:border-red-900 dark:bg-red-950/40 dark:text-red-200',
  staging:
    'border-amber-300 bg-amber-50 text-amber-800 dark:border-amber-900 dark:bg-amber-950/40 dark:text-amber-200',
  development:
    'border-emerald-300 bg-emerald-50 text-emerald-800 dark:border-emerald-900 dark:bg-emerald-950/40 dark:text-emerald-200',
  test: 'border-blue-300 bg-blue-50 text-blue-800 dark:border-blue-900 dark:bg-blue-950/40 dark:text-blue-200'
}

export default function AdminEnvironmentBadge({ environment }) {
  const normalized = String(environment || 'unknown').toLowerCase()
  const className =
    ENVIRONMENT_STYLES[normalized] ||
    'border-gray-300 bg-gray-50 text-gray-700 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200'

  return (
    <span
      className={`inline-flex min-h-7 items-center border px-2 text-[11px] font-semibold uppercase ${className}`}
      title={`Environment: ${normalized}`}
    >
      {normalized}
    </span>
  )
}
